module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/2e3a27802ff29e3a9faeda0c48c0d7e2.jpg";